import React from 'react';

import OnboardWorkingHours from '../components/OnboardWorkingHours';

// Title/description now render in SystemModal's own header (see onboard/modals/index.js) —
// this used to duplicate them locally inside a PaperBlock nested in the legacy Modal's paper.
const WorkingHoursModal = () => <OnboardWorkingHours />;

export default WorkingHoursModal;
